// import { pdf } from '@react-pdf/renderer';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
// import SalesInvoicePDF from '../../components/StockReports/SalesInvoicePDF'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'branches/'

const initialState = {
    masterData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const branchList = createAsyncThunk('br/brList', async (getOrder, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'branchList', getOrder)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getBranchData = createAsyncThunk('br/gbd', async (branchID, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getBranchData', branchID)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addNewBranch = createAsyncThunk('br/anb', async (branchData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addNewBranch', branchData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const counterSalesSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.masterData = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(branchList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(branchList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(branchList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = counterSalesSlice.actions

export default counterSalesSlice.reducer

